"use strict";
/**
 * Moderation `flags` canonical template — single source of truth for the
 * `moderation-flags` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY: the setup lambda registers them and
 * moderation-history reads them by alias. They have NO search-document interface
 * in shared-types and are NOT read by application search queries, so — unlike the
 * content families — they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants,
 * no new interface).
 *
 * The explicit field types are ported VERBATIM from the setup lambda's inline
 * `buildIndexDefinitions()` moderation-flags block. Moderation indexes used plain
 * mappings (no analyzers), so the `settings.analysis` block is intentionally
 * OMITTED. `content_snapshot` stays UNMAPPED — handled by `dynamic: true`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationFlagsTemplate = buildModerationFlagsTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-flags` family. */
function buildModerationFlagsTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    flag_id: { type: 'keyword' },
                    content_type: { type: 'keyword' },
                    content_id: { type: 'keyword' },
                    identity_id: { type: 'keyword' },
                    flagged_by_user_name: { type: 'keyword' },
                    flag_reason: { type: 'keyword' },
                    flag_comment: { type: 'text' },
                    status: { type: 'keyword' },
                    outcome: { type: 'keyword' },
                    resolved_by: { type: 'keyword' },
                    moderator_notes: { type: 'text' },
                    auto_blocked: { type: 'boolean' },
                    created_at: { type: 'date' },
                    resolved_at: { type: 'date' },
                    defendant_id: { type: 'keyword' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-flags' },
    };
}
